import { Icon, PopOver, Space, Text, Title } from "components/common"

const ReportTablePopOver = data => {
  const renderToolTipContent = () => {
    return data?.data?.map((item, index) => (
      <Space key={index} className="w-100" direction="vertical">
        {item?.heading && <Title level={3}>{item.heading}</Title>}
        {item?.paragraph && <Text block>{item.paragraph}</Text>}
        {item?.points?.length > 0 && (
          <ul>
            {item.points.map((point, pointIndex) => (
              <li key={pointIndex}>{point}</li>
            ))}
          </ul>
        )}
      </Space>
    ))
  }
  return (
    // <PopOver placement="right" content={renderToolTipContent()} overlayInnerStyle={{ width: 335 }}>
    <Icon
      hasBackground
      icon={"BsInfo"}
      color="#707070"
      size="16px"
      style={{ backgroundColor: "#E6E6E6", borderRadius: "1rem", "--icon-color": "#707070", margin: -8 }}
      className="pointer"
      iconContainerStyle={{ translate: "0 3px" }}
      tooltipText={renderToolTipContent()}
      placement="right"
    />
    // </PopOver>
  )
}

export default ReportTablePopOver
